import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpSectionPrice のスタイル
 */
export const hotlineLpSectionPriceStyle = tv({
    slots: {
        backgroundImage1: [
            'absolute -z-10',
            'w-[180px] left-[-135px] bottom-[25px]',
            'lg:w-[363px] lg:left-[-508px] lg:bottom-[-125px]',
        ],
        backgroundImage2: [
            'absolute -z-10',
            'w-[393px] right-[-250px] top-[-255px]',
            'lg:w-[782px] lg:right-[-576px] lg:top-[-295px]',
        ],
        base: ['mx-20 text-[#231916]', 'flex flex-col items-center'],
        description: [
            'text-[14px] leading-[21px]',
            'max-lg:mx-12',
            'lg:text-[16px] lg:leading-[29px]',
        ],
        fileIcon: ['text-[66px]'],
        fileIconWrapper: [
            'mt-20',
            'flex max-lg:flex-col items-center lg:gap-x-[10px] max-lg:gap-y-20',
        ],
        hr: ['bg-[#A6C3F2] border-none h-[1px]', 'w-full lg:max-w-[1020px]'],
        listItemWrapper: [
            'p-16 lg:p-[14px]',
            'text-center',
            'text-[14px] leading-[25px]',
            'lg:text-[16px] lg:leading-[29px]',
        ],
        listWrapper: [
            'mt-20',
            'grid grid-cols-1 gap-y-16',
            'lg:grid-cols-2 lg:gap-8',
            'lg:max-w-[1020px] lg:mx-auto w-full',
        ],
        priceSlash: [
            'text-[16px] leading-[23px]',
            'px-[2px] lg:pr-12 lg:pl-4',
            'lg:text-[24px] lg:leading-[35px]',
        ],
        priceText: [
            'text-[24px] leading-[35px] font-bold',
            'lg:text-[32px] lg:leading-[46px]',
        ],
        priceWrapper: ['text-center', 'mt-16'],
        taxText: [
            'text-[12px] leading-[17px] font-bold',
            'lg:text-[16px] lg:leading-[23px]',
        ],
        title: [
            'text-[16px] leading-[24px] font-bold text-center',
            'mt-20 lg:mt-32',
            'lg:text-[18px] lg:leading-[26px]',
        ],
    },
});
